import Modal from 'bootstrap/js/src/modal';
import { showToast } from '../helpers/toastr';

const playlistModal = () => {
  $(() => {
    $('.js-player-playlist-modal').on('click', (event) => {
      event.preventDefault();
      const modalElement = document.querySelector(event.currentTarget.dataset.playlistModalTarget);
      const playerModalElement = document.getElementById('playerModal');
      const playerModal =
        playerModalElement && playerModalElement.classList.contains('show')
          ? Modal.getOrCreateInstance(playerModalElement)
          : null;

      if (!modalElement) return;

      if (playerModal) {
        // Bootstrap supports one active focus trap. Keep the player visible,
        // but hand focus management to the modal shown above it.
        // eslint-disable-next-line no-underscore-dangle
        playerModal._focustrap.deactivate();

        modalElement.addEventListener(
          'hidden.bs.modal',
          () => {
            window.requestAnimationFrame(() => {
              if (playerModalElement.classList.contains('show')) {
                // eslint-disable-next-line no-underscore-dangle
                playerModal._focustrap.activate();
              }
            });
          },
          { once: true },
        );
      }

      const playlistModalInstance = Modal.getOrCreateInstance(modalElement, { focus: false });
      // Focus traps cannot coexist while both modals remain visible.
      // eslint-disable-next-line no-underscore-dangle
      playlistModalInstance._focustrap.deactivate();
      playlistModalInstance.show(event.currentTarget);
    });

    $('.js-playlist-modal-submit').on('click', (event) => {
      event.preventDefault();
      const { chapterId } = event.currentTarget.dataset;
      const { chapterIndex } = event.currentTarget.dataset;
      const modalId = $(`#playlist-modal-${chapterId}-${chapterIndex}`);
      const playlistCheckboxes = `js-playlist-checkboxes-${chapterId}-${chapterIndex}`;
      const playlistIds = $(`.${playlistCheckboxes}:checkbox:checked`)
        .map(function playlistId() {
          return $(this).val();
        })
        .get();
      if (playlistIds.length > 0) {
        const authToken = $('meta[name=csrf-token]').attr('content');
        const chapters = {
          chapter: {
            playlist_ids: playlistIds,
          },
          authenticity_token: authToken,
        };
        $.ajax({
          url: `/chapters/${chapterId}`,
          type: 'PUT',
          data: JSON.stringify(chapters),
          dataType: 'JSON',
          contentType: 'application/json',
          success() {
            showToast('success', 'Lesson added successfully');
          },
          error() {
            showToast('error', 'Oops! Something went wrong. Please try again later.');
          },
        });
        Modal.getOrCreateInstance(modalId[0]).hide();
        $('.modal-backdrop').remove();
      } else {
        showToast('error', 'Select at least one playlist to add a chapter');
      }
    });

    $('.js-modal-create-playlist').on('click', (event) => {
      event.preventDefault();
      const modalId = `#${event.currentTarget.dataset.modalId}`;
      Modal.getOrCreateInstance($(modalId)[0]).hide();
      window.location.href = event.target.href;
    });
  });
};

export default playlistModal;
